import { useEffect, useState } from 'react';
import supabase from '../supabase/supabase';
import { SLOTS, TABLE } from '../data/imageSlots';

let cache = null;

async function load() {
  const { data } = await supabase.from(TABLE).select('slot_key,url,title');
  const rows = {};
  (data || []).forEach((row) => { rows[row.slot_key] = row; });
  cache = rows;
  return rows;
}

export function useSiteImages() {
  const [rows, setRows] = useState(cache);
  useEffect(() => {
    if (cache) return;
    load().then(setRows).catch(() => {});
  }, []);
  const find = (key) => SLOTS.find((slot) => slot.key === key) || {};
  return {
    url: (key) => rows === null ? '' : (rows[key] && rows[key].url) || find(key).url || '',
    title: (key) => rows === null ? '' : (rows[key] && rows[key].title) || find(key).title || ''
  };
}